
import React, { useContext } from 'react'
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardFooter,
	Col,
	ListGroup,
	ListGroupItem,
	Modal,
	ModalBody,
	ModalFooter,
	Row
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { SpinnerComponent } from 'react-element-spinner'

import VehiclesService from '../../services/VehiclesService'
import { SessionContext } from '../../contexts/SessionProvider'
import { VehiclesContext } from '../../contexts/VehiclesProvider'
import Paginator from '../../components/Paginator/Paginator'
import SiteService from '../../services/SiteService'
import {trigger} from '../../events/customEvents'

const SelectVehicleModal = ({ showSelectVehicleModal = false, adminAuctionId = '' }) =>
{
	const [isModalBusy, setIsModalBusy] = React.useState(false)
	const sessionContext = useContext(SessionContext)
	const [pagingResult, setPagingResult] = React.useState({ pageCollection: [], totalRecords: 0 })
	const { t } = useTranslation()
	const vehiclesContext = useContext(VehiclesContext)
	
	const retrieveSearchResults = (searchRequest) =>
	{
		setIsModalBusy(true)
		VehiclesService
			.searchVehicles(searchRequest, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsModalBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				setPagingResult(result.data.actionResult)
			})
			.catch((error) =>
			{
				setIsModalBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const handleOnOpened = () =>
	{
		retrieveSearchResults(vehiclesContext.searchRequest)
	}
	
	const handlePageChange = (e) =>
	{
	
	}
	
	const handleSelectVehicle = (vehicle) =>
	{
		trigger('selectVehicleModalClosed', { vehicleId: vehicle.vehicleId, adminAuctionId: adminAuctionId })
	}
	
	const handleCancelModal = () =>
	{
		trigger('selectVehicleModalClosed', { vehicleId: undefined, adminAuctionId: undefined })
	}
	
	return (
		<>
			<Modal
				size="lg"
				fullscreen="md"
				isOpen={showSelectVehicleModal}
				onOpened={handleOnOpened}
			>
				<SpinnerComponent
					loading={ isModalBusy }
					position="centered"
					color="#3578e5"
					secondaryColor="#f3f3f3"
					backgroundColor="#d3d3d3"
					spinnerType="circle-dots"
				/>
				<ModalBody>
					<Card>
						<CardHeader className="text-center" style={{padding: '1rem 0.75rem'}}>
							<h3 className="mb-0">Select Vehicle</h3>
						</CardHeader>
						<CardBody>
							<ListGroup className="list my--3" flush>
								{
									pagingResult.pageCollection.map((pageItem, pgItemIdx) => (
										<ListGroupItem style={{cursor: 'pointer'}} className="px-0" key={pgItemIdx} onClick={() => handleSelectVehicle(pageItem)}>
											<Row className="align-items-center">
												<Col xs={12} className="text-primary">
													<div style={{marginLeft: '5px', cursor: 'pointer'}}>
														<label style={{fontSize: '12px', cursor: 'pointer'}}>
															{ pageItem.year + ' ' + pageItem.make + ' ' + pageItem.model + ' ' + pageItem.trim }
														</label>
													</div>
													<div style={{marginLeft: '5px', cursor: 'pointer'}}>
														<label style={{ fontSize: '12px', cursor: 'pointer' }}>{ pageItem.serialNumber }</label>
													</div>
												</Col>
											</Row>
										</ListGroupItem>
									))
								}
							</ListGroup>
						</CardBody>
						<CardFooter className="py-4">
							<nav aria-label="...">
								<Paginator
									currentPage={vehiclesContext.searchRequest.pageIndex}
									pages={parseInt(((pagingResult.totalRecords - 1) / vehiclesContext.searchRequest.pageSize) + 1, 10)}
									selectPage={handlePageChange}
								/>
							</nav>
						</CardFooter>
					</Card>
				</ModalBody>
				<ModalFooter>
					<div className="text-center">
						<Button
							className="my-4"
							color="primary"
							type="button"
							size="sm"
							onClick={() => handleCancelModal()}
						>
							{t('Modals.PlaceMemberBid.Cancel')}
						</Button>
					</div>
				</ModalFooter>
			</Modal>
		</>
	)
}

export default SelectVehicleModal
